// extracted by mini-css-extract-plugin
export var divider = "_v7-0";